/***************************************************************************

    Copyright (C) 2020 Ravenpod, Inc.
    All rights reserved.

    This material contains CONFIDENTIAL INFORMATION
    that is the property of Ravenpod.com, Inc.
    Any unauthorized use, duplication or disclosure is prohibited.

***************************************************************************/

import Vue from 'vue'
import VueRouter from 'vue-router'
import { Auth } from 'aws-amplify';

Vue.use(VueRouter)

const routes = [

    { path: '/ravenpodCrystal', name: 'ravenpodCrystal', component: () => import('@/views/public/RavenpodCrystal.vue') },
    { path: '/ravenpodSapphire', name: 'ravenpodSapphire', component: () => import('@/views/public/RavenpodSapphire.vue') },
    { path: '/', name: 'home', component: () => import('@/views/public/Home.vue') },
    { path: '/about', name: 'about', component: () => import('@/views/public/About.vue') },
    { path: '/contact', name: 'contact', component: () => import('@/views/public/ContactUs.vue') },
    { path: '/pricing', name: 'pricing', component: () => import('@/views/public/Pricing.vue') },
    {
        path: '/docs',
        name: 'docs',
        beforeEnter(to, from, next) {
            window.location.replace("https://docs.ravenpod.com/guide")
        }
    },
    { path: '/auth', name: 'auth',
        component: () => import('@/views/Auth.vue'),
        props: route => ({ ...route.query, ...route.params })
    },
    {
        path: '/main',
        name: 'main',
        component: () => import('@/views/Main.vue'),
        children: [
            { path: 'businessTransactionTracking', name: 'businessTransactionTracking', component: () => import('@/components/AssetTrackingTable.vue') },
            { path: 'problemDeterminationDashboard', name: 'problemDeterminationDashboard', component: () => import('@/components/PDDashboard.vue') },
            { path: 'webTierDrilldown', name: 'webTierDrilldown', component: () => import('@/views/WebTierDrilldown.vue') },
            { path: 'blockchainTierDrilldown', name: 'blockchainTierDrilldown', component: () => import('@/views/BlockchainTierDrilldown.vue') },                
        ],
        meta: { requiresAuth: true}                
    },
    { path: '/profile', name: 'profile', component: () => import('@/views/Profile.vue'), meta: { requiresAuth: true} },


]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }    
})

router.beforeResolve((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        Auth.currentAuthenticatedUser().then(() => {
            if (to.name == 'main') {
                next({ name: 'problemDeterminationDashboard' })
            } else {
                next()
            }            
        }).catch(() => {
            next({
                name: 'auth',
                params: { initAuthState: 'signin', targetNamedRoute: to.name }          
            });
        });
    } 
    next()
})

export default router
